module.exports = __webpack_public_path__ + "static/media/main_bgrnd.30dfdd8d.png";